export const MACHINE_DASH = {
  optichiller2comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/optichiller2comp/dashboard",
  },
  centrifuga: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/centrifuga/dashboard",
  },
  cotherm2comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/cotherm2comp/dashboard",
  },
  cotherm4comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/cotherm4comp/dashboard",
  },
  cotherm4comp2cc: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/cotherm4comp2cc/dashboard",
  },
  ezchiller2compct6: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/ezchiller2compct6/dashboard",
  },
  fsc: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecooling/dashboard",
  },
  fsc_1comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecooling1comp/dashboard",
  },
  fsc_unico: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingunico/dashboard",
  },
  fsc_v2_1comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingv21comp/dashboard",
  },
  fsc_v3: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingv3/dashboard",
  },
  fsc_v3_1comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingv31comp/dashboard",
  },
  licuador1comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/licuador1comp/dashboard",
  },
  optichiller_ct6: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/optichiller2compct6/dashboard",
  },
  optichiller1comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/optichiller1comp/dashboard",
  },
  optichiller1comp_ct6: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/optichiller1compct6/dashboard",
  },
  victex1comp: {
    endpoint:
      "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/victex1compresor/dashboard",
  },
};